export default __webpack_public_path__ + "static/winter15-602e8ccbd9a8171ca70669c37500eb65.webp";